var nb = require('../../nb');
var accountItem = require('../../view/header/AccountMenu').accountItem;
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        accountList:nb.model.List
    },
    method:{
        init:function () {
            var list =  [{
                href: 'order.html',
                linkName: '我的订单'
            }, {
                href: 'wish.html',
                linkName: '心愿单',
                className: 'wish',
                iconName: 'icon-heart-empty'
            }, {
                href: 'account.html',
                linkName: '账号设置'
            }, {
                href: 'address.html',
                linkName: '我的地址'
            }, {
                href: 'coupon.html',
                linkName: '我的优惠券'
            },  {
                href: '#',
                className: 'exit',
                linkName: '退出登录'
            }];
            var accountList =  this.get('accountList');
            accountList.setOpts({
                itemType:accountItem,
                items:list
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/header/AccountMenu.js
// module id = 36
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32